import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsbEnum } from "@/utils/indicatorsEsb";
import { ResumeIndicatorB4Data } from "@/services/esus/indicator/esb/b4/getResumeIndicatorB4";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsbB4ResumeProps = {
	resume: ResumeIndicatorB4Data;
};

export function IndicatorEsbB4Resume({ resume }: Readonly<IndicatorEsbB4ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalCitizensFinished,
		resume.totalCitizens
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos vinculados"
					value={resume.totalCitizens.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos vinculados"
							message="Quantidade de cidadãos vinculados a equipes ESF/EAP e ESB com idade de 6 a 12 anos no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos vinculados com escovação supervisionada"
					value={resume.totalCitizensFinishedLinked.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos vinculados com escovação supervisionada"
							message=" "
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos vinculados a equipes ESF/EAP, com idade de 6
								a 12 anos, <br />
								que realizaram escovação supervisionada no período pela equipe
								ESB de <br />
								referência a equipe ESF/EAP do cidadão
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos não vinculados com escovação supervisionada"
					value={(
						(resume.totalCitizensFinished ?? 0) -
						(resume.totalCitizensFinishedLinked ?? 0)
					).toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Cidadãos não vinculados com escovação supervisionada"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Quantidade de cidadãos distintos por equipe, com idade entre 6 e 12
								anos, que <br />
								realizaram escovação supervisionada no período por alguma
								equipe ESB que <br />
								não tem vínculo com a ESF/EAP do cidadão. <br />
								Obs: em casos de cidadãos com escovações supervisionadas realizadas
								por mais de <br />1 equipe, serão contabilizadas as escovações
								supervisionadas em ambas as equipes.
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Classificação"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsbEnum.B4,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="Classificação"
							icon={<FaInfoCircle className="text-muted" />}
						>
							<div className="text-start">
								Percentual de cidadãos com escovação supervisionada em relação aos
								cidadãos <br />
								com idade entre 6 e 12 anos vinculados a equipes ESF/EAP e ESB
							</div>
						</CardOverlayTrigger>
					}
				/>
			</Col>
		</Row>
	);
}
